import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { storeUser } from '../utils/tokens';
import { EventBus } from '../eventBus';

const consoleUrl = process.env.REACT_APP_CONSOLE_REDIRECT;

export const Transfer = () => {
	const [authed, setAuthed] = useState(false);
	const [consoleUrl, setConsoleUrl] = useState('#');
	const location = useLocation();
	const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const navigate = useNavigate();

	if (authed) {
		navigate('/resources');
	}

	useEffect(() => {
		setConsoleUrl(consoleUrl);
		const authKey = params.get('token');
		getTokens(authKey).then(() => {
			setAuthed(true);
		});
	}, [params, consoleUrl]);

	/**
	 *
	 * @returns {Promise<*>}
	 * @param authKey
	 */
	const getTokens = async authKey => {
		const response = await axios.get('useraccount/login-with-auth-code?code=' + authKey);
		storeUser(response);
		EventBus.$emit('authChange', true);
		return response;
	};

	return <TransferWaiting />;
};

const TransferWaiting = () => {
	return (
		<>
			<div className="flex min-h-full flex-col bg-white pt-16 pb-12">
				<main className="mx-auto flex w-full max-w-7xl flex-grow flex-col justify-center px-4 sm:px-6 lg:px-8">
					<div className="py-16">
						<div className="text-center">
							<h1 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
								Loading...
							</h1>
							<div className="mt-6">
								<a
									href={consoleUrl}
									className="text-base font-medium text-indigo-600 hover:text-indigo-500">
									Go back to Console
									<span aria-hidden="true"> &rarr;</span>
								</a>
							</div>
						</div>
					</div>
				</main>
			</div>
		</>
	);
};
